import axios from 'axios';

export const decodingAddress = async (address) => {
  const response = await axios.get(
    `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=${process.env.NEXT_PUBLIC_GOOGLE_STATIC_MAP_API_KEY}`
  );
  return response.data;
};

export const getAddresByGeo = async (data) => {
   const response = await axios.get(
    `https://maps.googleapis.com/maps/api/geocode/json?latlng=${data.lat}, ${data.lng}&key=${process.env.NEXT_PUBLIC_GOOGLE_STATIC_MAP_API_KEY}`
  );
  return response.data;
}